var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutC8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feLogout0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feLogout1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feLogout2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.9 0.9 0 2 0H10V2H2V16H10V18H2C0.9 18 0 17.1 0 16V2ZM14.176 8L11.64 5.464L13.054 4.05L18.004 9L13.054 13.95L11.64 12.536L14.176 10H7.59V8H14.176Z",
    fill: "#C84848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutC8);
export default __webpack_public_path__ + "static/media/logout-c8.c43e7cbd28136212b334f2764ca37190.svg";
export { ForwardRef as ReactComponent };